import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { COMPANY_HEADERS, ONE, ZERO } from '@/constants';
import {
  PageHeaderLayout,
  Pagination,
  Search,
  Table,
  TableContainer,
} from '@/ui';

import type { ChangeEvent } from 'react';

import List from '@/components/Companies/List';
import Header from '@/components/Companies/List/Header';
import { useGetCompaniesQuery } from '@/store/api/companyApi';

const Companies = () => {
  const [page, setPage] = useState<number>(ONE);
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  const { data, isLoading } = useGetCompaniesQuery({ page, search });

  useEffect(() => {
    setPage(ONE);
  }, [search]);

  useEffect(() => {
    const total = data?.total ?? 0;
    const items = data?.items ?? [];
    if (!isLoading && total === 1 && items.length === 1) {
      const only = items[0];
      if (only && only.id) {
        navigate(`/company/${only.id}`, { replace: true });
      }
    }
  }, [isLoading, data, navigate]);

  const onPageChange = (_: ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <div className="w-full p-4">
      <PageHeaderLayout title="Companies" />

      <Search
        className="mt-4 w-full md:w-1/3"
        search={search}
        setSearch={setSearch}
      />

      <div className="flex flex-1 flex-col pt-4">
        <TableContainer>
          <Table aria-label="companies table">
            <Header headers={COMPANY_HEADERS} />
            <List
              companies={data?.items || []}
              headers={COMPANY_HEADERS}
              isLoading={isLoading}
            />
          </Table>
        </TableContainer>
        <Pagination
          count={data?.pages ?? ZERO}
          page={page}
          onChange={onPageChange}
        />
      </div>
    </div>
  );
};

export default Companies;
